import { latestItems } from "@/mocks/home";

export default function LatestFeed() {
  return (
    <div>
      <div className="flex items-end justify-between gap-4 pb-4 border-b-2 border-foreground-950">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新爆料</h2>
          <p className="mt-1 text-xs text-foreground-500">按发布时间倒序 · 每分钟刷新</p>
        </div>
        <a href="#collections" className="text-xs text-primary-600 hover:text-primary-700 whitespace-nowrap flex items-center gap-1">
          全部合集
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        </a>
      </div>

      <ul className="divide-y divide-background-200">
        {latestItems.map((item) => (
          <li key={item.title}>
            <a href="#today" className="group flex gap-4 py-5">
              <div className="hidden sm:flex flex-col items-center shrink-0 w-12">
                <span className="font-heading text-sm font-bold text-foreground-800 tabular-nums">{item.time}</span>
                <span className="mt-2 flex-1 w-px bg-background-300 min-h-[36px]"></span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap mb-1.5">
                  <span className="px-2 py-0.5 rounded-sm bg-secondary-100 text-secondary-900 text-[11px] font-label">
                    {item.tag}
                  </span>
                  <span className="sm:hidden text-xs text-foreground-400 tabular-nums">{item.time}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true"></i>
                    {item.reads}
                  </span>
                </div>
                <h3 className="text-[15px] md:text-base font-medium leading-6 text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600 line-clamp-2">{item.summary}</p>
              </div>
            </a>
          </li>
        ))}
      </ul>

      <a
        href="#stars"
        className="mt-4 h-11 w-full rounded-md border border-foreground-300 text-foreground-800 text-sm font-label flex items-center justify-center gap-2 hover:bg-background-100 transition-colors"
      >
        加载更多爆料
        <i className="ri-arrow-down-line" aria-hidden="true"></i>
      </a>
    </div>
  );
}